import React, { useCallback, useState } from 'react';

import {
  Button,
  Slide,
  Box,
  Tab,
  Tabs,
  Divider,
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { useParams } from 'react-router-dom';
import { useGetOne } from 'react-admin';

import Requests from './Requests';
import RequestForm from './RequestForm';
import { ICase } from '../../../../../utilities/schemas/case';
import useDialogStatus from '../../../../../hooks/useDialogStatus';

const Create = () => {
  const { open, openDialog, closeDialog } = useDialogStatus();
  const [value, setValue] = useState<'case' | 'all' | 'custom'>('case');

  const { caseId } = useParams();
  const { data } = useGetOne<ICase>('cases', { id: caseId! }, { enabled: !!caseId });

  const handleChangeTab = useCallback((_event: React.SyntheticEvent, newValue: 'case' | 'all' | 'custom') => {
    setValue(newValue);
  }, []);

  return (
    <>
      <Slide direction="right" in={!open} appear={false}>
        <Box display={open ? 'none' : 'block'}>
          <Tabs value={value} onChange={handleChangeTab}>
            <Tab value="case" label="Case requests" />
            <Tab value="all" label="All requests" />
            <Tab value="custom" label="Custom" />
          </Tabs>
          <Divider />
          <Box marginTop={4}>
            {value === 'case' && data && <Requests requests={data?.requests} handleOpenChange={openDialog} />}
            {value === 'all' && data && <Requests handleOpenChange={openDialog} entities={data?.entities.map((entity) => entity.id)} />}
            {value === 'custom' && (
              <RequestForm />
            )}
          </Box>
        </Box>
      </Slide>
      <Slide direction="left" in={open}>
        <Box display={!open ? 'none' : 'block'}>
          <Box marginBottom={4}>
            <Button startIcon={<ArrowBackIosNewIcon />} onClick={closeDialog}>
              Back
            </Button>
          </Box>
          <RequestForm />
        </Box>
      </Slide>
    </>
  );
};

export default Create;
